import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useAdminCan } from "@/pages/admin/adminCards";

// Professional, reusable "insufficient permission" experience.
// Admin Center is offered only to people who can actually open it; Agents/Agent Staff get Dashboard / Go Back.
export function AccessDenied({
  title = "You don't have permission to view this",
  message = "Your role doesn't include access to this page. If you think this is a mistake, contact your administrator.",
  primaryTo,
  primaryLabel,
}) {
  const navigate = useNavigate();
  const { isOfficeUser } = useAuth();
  const { hasAdmin } = useAdminCan();
  const admin = !isOfficeUser && hasAdmin;
  const to = primaryTo || (admin ? "/admin/center" : null);
  const label = primaryLabel || (admin ? "Back to Admin Center" : "Go Back");
  return (
    <div className="flex items-center justify-center py-20 px-4" data-testid="access-denied">
      <div className="max-w-md w-full text-center rounded-2xl border border-slate-200 bg-white p-10 shadow-sm">
        <div className="mx-auto w-14 h-14 rounded-full bg-amber-50 text-amber-500 flex items-center justify-center mb-5">
          <ShieldAlert className="w-7 h-7" />
        </div>
        <h1 className="font-display text-xl font-bold text-slate-900">{title}</h1>
        <p className="text-sm text-slate-500 mt-2">{message}</p>
        <div className="mt-6 flex items-center justify-center gap-2">
          <Button variant="outline" onClick={() => navigate("/")} data-testid="access-denied-home">Go to Dashboard</Button>
          <Button className="bg-[#006090] hover:bg-[#004E75]" onClick={() => (to ? navigate(to) : navigate(-1))} data-testid="access-denied-primary">{label}</Button>
        </div>
      </div>
    </div>
  );
}

export function ComingSoon({ title = "Coming soon", message = "This area isn't available yet. Check back shortly." }) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center py-20 px-4" data-testid="coming-soon">
      <div className="max-w-md w-full text-center rounded-2xl border border-slate-200 bg-white p-10 shadow-sm">
        <h1 className="font-display text-xl font-bold text-slate-900">{title}</h1>
        <p className="text-sm text-slate-500 mt-2">{message}</p>
        <div className="mt-6"><Button className="bg-[#006090] hover:bg-[#004E75]" onClick={() => navigate("/")}>Go to Dashboard</Button></div>
      </div>
    </div>
  );
}

export default AccessDenied;
